package br.com.vvrefeicoes.portal.domain.model

data class CompanyEmotion(
    val id: String,
    val emoji: String,
    val name: String,
    val responses: List<CompanyEmotionResponse> = emptyList(),
)

data class CompanyEmotionResponse(
    val id: String?,
    val text: String,
    val custom: Boolean,
)
